import * as types from '../constants/actionTypes';
import update from 'immutability-helper';

const INITIAL_STATE = {};

export default function submission(state = INITIAL_STATE, action) {
    switch (action.type) {

        case types.SUBMISSION__CLEAR__REQUESTED: {
            return INITIAL_STATE;
        }

        case types.DROPBOX__ASSIGNMENT__SUBMISSION__REQUESTED__SUCCEEDED: {
            return {
                ...action.payload.submission,
            };
        }

        case types.SUBMISSION__UPDATE__REQUESTED: {
            return {
                ...action.payload.submission
            };
        }

        case types.SUBMISSION__UPDATE__NOTDONE__REQUESTED: {
            return {
                ...action.payload.submission
            };
        }

        case types.SUBMISSION__CREATE__REQUESTED__SUCCEEDED: {
            return {
                ...action.payload.submission,
            };
        }

        case types.FILE__UPLOAD__REQUEST__SUCCEEDED: {
            const files = state.submission_files;
            let file_index = null;
            for(let i in files){
                if (files[i].name === action['file'].name){
                    file_index = i;
                    break;
                }
            }

            let newState = update(state, {
                submission_files: {
                    [file_index]: {
                        size: {$set: action.file.size},
                        progress: { $set: 100},
                        updated : { $set: action.file.updated},
                        id : { $set: action.file.id}
                    }
                }
            });

            return {
                ...state,
                submission_files: newState.submission_files
            };
        }

        case types.FILE__UPLOAD__REQUEST__FAILED: {
            const files = state.submission_files;
            let file_index = null;
            for(let i in files){
                if (files[i].name === action.files['file'].name) {
                    file_index = i;
                    break;
                }
            }

            let newState = update(state, {
                submission_files: {
                    [file_index]: {
                        progress: { $set: -1}
                    }
                }
            });

            return {
                ...state,
                submission_files: newState.submission_files
            };
        }

        case types.FILE__UPLOAD__BAD__REQUEST: {
            const files = state.submission_files;
            let file_index = null;
            for(let i in files){
                if (files[i].name === action.files['file'].name) {
                    file_index = i;
                    break;
                }
            }

            let newState = update(state, {
                submission_files: {
                    [file_index]: {
                      progress: { $set: -1}
                    }
                }
            });

            return {
                ...state,
                submission_files: newState.submission_files
            };
        }

        case types.FILE__UPLOAD__REQUESTED: {
            const files = state.submission_files;
            const assignment = state.assignment;
            let file_index = null;
            for(let i in files){
                if (files[i].name === action.payload['file'].name){
                    file_index = i;
                    break;
                }
            }

            if (file_index !== null) {

                let newState = update(state, {
                    submission_files: {
                        [file_index]: {
                            progress: {$set: 0}
                        }
                    }
                });

                return {
                    ...state,
                    submission_files: newState.submission_files,
                    assignment_updated: assignment.updated
                };
            }else {

                const newFile = {
                    'name': action.payload.file.name,
                    'size': action.payload.file.size,
                    'progress': 0
                };

                return {
                    ...state,
                    submission_files: [...state.submission_files, newFile],
                    assignment_updated: assignment.updated
                };

            }
        }

        case types.DROPBOX__ASSIGNMENT__SUBMISSION__REQUESTED__FAILED: {
            //submission does not exist
            return  {
                ...state,
                id: null
            };
        }

        case types.SUBMISSION__UPDATE__REQUESTED__SUCCEEDED: {
            return {
                ...action.payload.submission,
            };
        }

        case types.SUBMISSION__UPDATE__NOTDONE__REQUESTED__SUCCEEDED: {
            return {
                ...action.payload.submission,
            };
        }

        case types.FILE__DELETE__REQUEST__SUCCEEDED: {
            let submission_files = state.submission_files.filter((assignment) => {
                return action.file.name !== assignment.name;
            });

            return {
                ...state,
                submission_files: submission_files
            };
        }

        case types.RUNSCRIPT__REQUESTED__SUCCEEDED: {
            return Object.assign({}, state, {
                ...state,
                attempts: state.attempts+1
            });
        }

        case types.SUBMISSION__CONFIRMATION__REQUESTED__SUCCEEDED: {
            return {
                ...action.payload.submission,
            };
        }

        case types.SUBMISSION__MEMBERSHIP__DECLINE__REQUESTED__SUCCEEDED: {
            return {
                ...state,
                id: '-1',
            };
        }

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/submissionReducer.js
 **/